/*
 * @Author: dengyong dengyong@caohua.com
 * @Date: 2022-08-10 14:55:09
 * @LastEditors: yangyi
 * @LastEditTime: 2022-09-29 11:31:19
 * @FilePath: \tiangong.caohua.com\tiangong\src\views\tools\data\toutiaogame_config_column.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default [
  {
    title: '草花游戏ID',
    key: 'gameId',
    width: 80,
    align: 'left'
  },
  {
    title: '游戏名称',
    key: 'gameName',
    width: 200,
    align: 'left'
  },

  {
    title: '应用包名',
    key: 'packageName',
    width: 100,
    align: 'left'
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: 80,
    align: 'left'
  },
  {
    title: '分包账号ID/组织ID',
    key: 'acId',
    width: 100,
    align: 'left'
  },
  {
    title: '分包应用ID',
    key: 'appId',
    width: 80,
    align: 'left'
  },
  {
    title: '分包池数量',
    key: 'poolSize',
    width: 60,
    align: 'left'
  },
  {
    title: '空闲的分包数',
    key: 'freeSize',
    width: 80,
    align: 'left'
  },
  {
    title: '可用分包数',
    key: 'availableNum',
    width: 80,
    align: 'left'
  },
  {
    title: '分包池触发创建比例',
    key: 'freeSpace',
    width: 100,
    align: 'left'
  },
  {
    title: '分包历史总数量',
    key: 'historyExtendPackageNum',
    width: 80,
    align: 'left'
  },
  {
    title: '分包配置时间',
    key: 'operationTime',
    width: 110,
    align: 'left'
  },
  {
    title: '操作',
    key: 'control',
    width: 80,
    align: 'left'
  }
]
